import React from "react";
import { useAuthStore } from "../../store/authStore";
import StudentDashboard from "./components/StudentDashboard";
import TeacherDashboard from "./components/TeacherDashboard";
import DashboardAdmin from "../../components/Admin/DashboardAdmin";

const Dashboard = () => {
  const { user } = useAuthStore();

  const renderDashboard = () => {
    if (!user) {
      return <div className="text-center text-gray-500">Loading user...</div>;
    }

    switch (user.role) {
      case 'admin':
        return <DashboardAdmin />;
      case 'teacher':
        return <TeacherDashboard />;
      case 'student':
        return <StudentDashboard />;
      default:
        return (
          <div className="text-center text-red-500">
            Unknown role: <strong>{user.role}</strong>
          </div>
        );
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      {renderDashboard()}
    </div>
  );
};

export default Dashboard;
